import { useMemo } from 'react';

import { DEFAULT_LOCALE, SiteLocale } from 'constants/i18n.constants';
import { useLocale } from 'hooks/useLocale';

export const useIntlDisplayNames = (
  localeOverwrite?: SiteLocale,
): Intl.DisplayNames => {
  const { locale } = useLocale();
  return useMemo(() => {
    try {
      return new Intl.DisplayNames(localeOverwrite ?? locale, {
        type: 'region',
      });
    } catch (error) {
      return new Intl.DisplayNames(DEFAULT_LOCALE, {
        type: 'region',
      });
    }
  }, [locale, localeOverwrite]);
};
